import React, { useState } from "react";
import moment from "moment";
import toast from "react-hot-toast";
import Loader from "../../../components/Loader";
import NoData from "../../../components/NoData";
import { MdPreview } from "react-icons/md";
import { MdClose } from "react-icons/md";
import PlaceBetServices from "../../../services/PlaceBetServices";
import PlaceBetDetailYantraList from "../../pleace_bet/components/PlaceBetDetailYantraList";

const TransactionHistoryComponent = (props) => {
  const {
    userId,
    rows,
    loading,
    page,
    pagination,
    limit,
    setLimit,
    setPage,
    user,
    setDetailsOpen,
    setDetailsLoading,
    setDetails,
    openDetails,
  } = props;

  const api = new PlaceBetServices();
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);

  const openDetailModal = async (r) => {
    setDetailModalOpen(true);
    setSelectedDetail(null);
    setDetailLoading(true);
    try {
      const res = await api.getPlaceBetById(r.id);
      if (res?.isSuccess && res?.data) {
        setSelectedDetail(res.data);
      } else {
        toast.error(res?.message || "Failed to load detail");
        setDetailModalOpen(false);
      }
    } catch (err) {
      console.error("getPlaceBetById error:", err);
      toast.error(err?.response?.data?.message || "Failed to load detail");
      setDetailModalOpen(false);
    } finally {
      setDetailLoading(false);
    }
  };

  const closeDetailModal = () => {
    setDetailModalOpen(false);
    setDetailLoading(false);
    setSelectedDetail(null);
  };

  const formatProfitLoss = (pl) => {
    if (!pl) return "—";
    if (pl.type === "EVEN") return "0.00";
    const val = Number(pl.value) || 0;
    const str = `${val.toFixed(2)}`;
    return pl.type === "PROFIT" ? `+${str}` : `-${str}`;
  };

  const resolveBetUserId = (detail) =>
    detail?.user?.user_id ??
    detail?.place_bet_data?.user_id ??
    null;

  return (
    <div>
      {loading ? (
        <Loader message="Loading transactions..." />
      ) : rows.length === 0 ? (
        <NoData
          message="No Transaction History Found"
          subText="Try changing date range or search keyword."
        />
      ) : (
        <>
          <div className="tx-table-bpl-scroll">
            <div className={`tx-table-header-trh`}>
              <div>Sr. No.</div>
              <div>Date</div>
              <div>Purchase</div>
              <div>Win</div>
              <div>Balance</div>
              <div>Barcode</div>
              <div>Action</div>
            </div>
            <div className={`tx-table-trh`}>
              {rows.map((r, index) => (
                <div className={`tx-row-trh`} key={r.id}>
                  <div>{index + 1}</div>
                  <div>
                    {r.created_at
                      ? moment
                          .utc(r.created_at)
                          .local()
                          .format("DD/MM/YYYY hh:mm A")
                      : "—"}
                  </div>
                  <div>{r.purchase_amount}</div>
                  <div>
                    {r.win_amount ? (
                      <span className="tx-bpl-credit">{r.win_amount}</span>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    <div style={{ fontWeight: 700 }}>
                      {r.balance_after_purchase}
                    </div>
                    <div className="tx-muted">
                      Before: {r.balance_before_purchase}
                    </div>
                  </div>
                  <div>{r.bar_code}</div>
                  <div>
                    <button
                      className="tx-view-btn"
                      onClick={() => openDetailModal(r)}
                    >
                      <MdPreview />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {pagination && pagination.totalPages > 1 && (
            <div className="modern-pagination">
              <div className="mp-limit">
                <span>Show</span>
                <select
                  value={limit}
                  onChange={(e) => setLimit(e.target.value)}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
              </div>

              <div className="mp-controls">
                <button disabled={page === 1} onClick={() => setPage(page - 1)}>
                  Prev
                </button>

                <div className="mp-info">
                  Page <strong>{pagination.page}</strong> of{" "}
                  <strong>{pagination.totalPages}</strong>
                </div>

                <button
                  disabled={page === pagination.totalPages}
                  onClick={() => setPage(page + 1)}
                >
                  Next
                </button>
              </div>

              <div className="mp-jump">
                <select value={page} onChange={(e) => setPage(e.target.value)}>
                  {Array.from({ length: pagination.totalPages }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      Page {i + 1}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </>
      )}

      {/* Detail Modal */}
      {detailModalOpen && (
        <div
          className="pbm-modal-overlay"
          onClick={() => !detailLoading && closeDetailModal()}
        >
          <div className="pbm-modal" onClick={(e) => e.stopPropagation()}>
            <div className="pbm-modal-header">
              <h3>Place Bet Details</h3>
              <button
                type="button"
                className="pbm-modal-close"
                onClick={() => !detailLoading && closeDetailModal()}
              >
                <MdClose size={18} />
              </button>
            </div>
            <div className="pbm-modal-body">
              {detailLoading ? (
                <Loader message="Loading detail..." />
              ) : selectedDetail ? (
                <>
                  {(() => {
                    const pb = selectedDetail.place_bet_data || {};
                    const isCancelled = Number(pb.isDelete) === 1;
                    const isScanned = Number(pb.isScan) === 1;
                    const isExpired = Number(pb.isScan) === 2;
                    const userName =
                      selectedDetail.user?.user_name ||
                      selectedDetail.user?.user_username ||
                      "—";
                    const gameId = selectedDetail.user?.user_username || "—";
                    const userRole = selectedDetail.user?.role_id || "—";
                    const status = isCancelled
                      ? { label: "Cancelled", cls: "cancelled" }
                      : isScanned
                        ? { label: "Scanned", cls: "scanned" }
                        : isExpired
                          ? { label: "Expired", cls: "expired" }
                          : { label: "Pending", cls: "pending" };

                    const winningAmt = Number(
                      selectedDetail.winning_amount ?? pb.win_amount ?? 0,
                    );

                    const createdAtLabel = pb.created_at
                      ? moment
                          .utc(pb.created_at)
                          .local()
                          .format("DD/MM/YYYY hh:mm A")
                      : "—";

                    return (
                      <>
                        <div className="pbm-detail-hero">
                          <div className="pbm-detail-hero-left">
                            <div className="pbm-detail-main">
                              {userName}
                              <span className="pbm-detail-game-id">
                                [{gameId}]
                              </span>
                            </div>

                            <div className="pbm-detail-uid">
                              {selectedDetail.placebet_uid || "—"}
                            </div>
                            <div className="pbm-detail-subline">
                              <span className="pbm-detail-dot">•</span>
                              <span>
                                {selectedDetail.session?.game_type ??
                                  pb.game_type ??
                                  "—"}
                              </span>
                              <span className="pbm-detail-dot">•</span>
                              <span>
                                #{selectedDetail.session?.session_no ?? "—"}
                              </span>
                              <span className="pbm-detail-dot">•</span>
                              <span>{createdAtLabel}</span>
                              {pb.draw_time ? (
                                <>
                                  <span className="pbm-detail-dot">•</span>
                                  <span>Draw: {pb.draw_time}</span>
                                </>
                              ) : null}
                              <span className="pbm-detail-dot">•</span>
                              <span>Bet: {pb.total_bet ?? "—"}</span>
                            </div>
                            {userRole !== 4 && (
                              <div className="pbm-detail-status">
                                <span className={`pbm-chip ${status.cls}`}>
                                  {status.label}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                        {!isCancelled && (
                          <div className="pbm-summary-row">
                            <div className="pbm-summary-item">
                              <span className="pbm-detail-label">Win: </span>
                              <span className="pbm-detail-value">
                                ₹{winningAmt.toFixed(2)}
                              </span>
                            </div>
                            <div className="pbm-summary-item">
                              <span className="pbm-detail-label">
                                Profit/Loss:{" "}
                              </span>
                              <span
                                className={
                                  selectedDetail.profit_or_loss?.type ===
                                  "PROFIT"
                                    ? "pbm-stat-pl profit"
                                    : selectedDetail.profit_or_loss?.type ===
                                        "LOSS"
                                      ? "pbm-stat-pl loss"
                                      : "pbm-stat-pl even"
                                }
                              >
                                {formatProfitLoss(
                                  selectedDetail.profit_or_loss,
                                )}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    );
                  })()}
                  <PlaceBetDetailYantraList
                    placeBetData={selectedDetail.place_bet_data}
                    winningYantraIds={selectedDetail.winning_yantra_ids}
                    betUserId={resolveBetUserId(selectedDetail)}
                    enabled={detailModalOpen}
                  />
                </>
              ) : (
                <NoData message="No detail available" />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionHistoryComponent;
